const ATTRIBUTION_STORAGE_KEY = 'neokasa_marketing_attribution_v1';

const TRACKING_QUERY_PARAMS = [
  'gclid',
  'dclid',
  'gbraid',
  'wbraid',
  'gad_source',
  'gad_campaignid',
  'gadcampaignid',
  'srsltid',
  'utm_id',
  'utm_source',
  'utm_medium',
  'utm_campaign',
  'utm_term',
  'utm_content',
  'utm_source_platform',
  'utm_creative_format',
  'utm_marketing_tactic',
];

const readStoredAttribution = () => {
  if (typeof window === 'undefined') {
    return null;
  }

  try {
    const raw = window.localStorage?.getItem(ATTRIBUTION_STORAGE_KEY);
    return raw ? JSON.parse(raw) : null;
  } catch (e) {
    return null;
  }
};

const writeStoredAttribution = data => {
  if (typeof window === 'undefined') {
    return;
  }

  try {
    window.localStorage?.setItem(ATTRIBUTION_STORAGE_KEY, JSON.stringify(data));
  } catch (e) {
    // Ignore storage errors.
  }
};

export const getTrackingParamsFromCurrentUrl = () => {
  if (typeof window === 'undefined') {
    return {};
  }

  const url = new URL(window.location.href);
  return TRACKING_QUERY_PARAMS.reduce((acc, key) => {
    const value = url.searchParams.get(key);
    if (value) {
      return { ...acc, [key]: value };
    }
    return acc;
  }, {});
};

export const captureTrackingParamsFromUrl = () => {
  if (typeof window === 'undefined') {
    return null;
  }

  const params = getTrackingParamsFromCurrentUrl();
  if (!Object.keys(params).length) {
    return readStoredAttribution();
  }

  const mergedData = {
    ...(readStoredAttribution() || {}),
    capturedAt: new Date().toISOString(),
    landingPath: `${window.location.pathname}${window.location.search}`,
    params: {
      ...(readStoredAttribution()?.params || {}),
      ...params,
    },
  };

  writeStoredAttribution(mergedData);
  return mergedData;
};

export const getStoredTrackingParams = () => {
  const stored = readStoredAttribution();
  return stored?.params || {};
};

export const getTrackingCampaignPayload = () => {
  const params = getStoredTrackingParams();
  if (!Object.keys(params).length) {
    return {};
  }

  const gadCampaignId = params.gad_campaignid || params.gadcampaignid;

  return {
    campaign_id: params.utm_id,
    campaign_source: params.utm_source,
    campaign_medium: params.utm_medium,
    campaign_name: params.utm_campaign,
    campaign_term: params.utm_term,
    campaign_content: params.utm_content,
    gclid: params.gclid,
    gbraid: params.gbraid,
    wbraid: params.wbraid,
    gad_source: params.gad_source,
    gad_campaignid: gadCampaignId,
    source_platform: params.utm_source_platform,
    creative_format: params.utm_creative_format,
    marketing_tactic: params.utm_marketing_tactic,
  };
};

export const removeTrackingParamsFromCurrentUrl = () => {
  if (typeof window === 'undefined') {
    return;
  }

  const url = new URL(window.location.href);
  let changed = false;

  TRACKING_QUERY_PARAMS.forEach(param => {
    if (url.searchParams.has(param)) {
      url.searchParams.delete(param);
      changed = true;
    }
  });

  if (changed) {
    window.history.replaceState({}, document.title, url.toString());
  }
};
